import { WORKSPACE_EMAIL_ALIAS_KINDS } from "@common/constants/domains/receipts/constants";
import { z } from "zod";

export const workspaceEmailAliasKindSchema = z.enum(
    WORKSPACE_EMAIL_ALIAS_KINDS,
);

export const workspaceEmailAliasSchema = z.object({
    emailLocalPart: z.string(),
    workspaceId: z.string().uuid(),
    limit: z.number().int().positive(),
    kind: workspaceEmailAliasKindSchema,
    counterpartyId: z.string().uuid().nullable(),
    entityUuid: z.string().uuid().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});

export type WorkspaceEmailAlias = z.infer<typeof workspaceEmailAliasSchema>;

const createChosenWorkspaceEmailAliasSchema = z
    .object({
        emailLocalPart: z.string().trim().min(1),
        kind: workspaceEmailAliasKindSchema.default("receipts"),
        counterpartyId: z.string().uuid().nullable().optional(),
    })
    .strict();

// Omitting the local part asks the server to generate a vendor address, which
// only means something for a counterparty on a bills or invoices alias.
const createGeneratedWorkspaceEmailAliasSchema = z
    .object({
        emailLocalPart: z.undefined(),
        kind: z.enum(["bills", "invoices"]),
        counterpartyId: z.string().uuid(),
    })
    .strict();

const createEntityCounterpartyWorkspaceEmailAliasSchema = z
    .object({
        customName: z
            .string()
            .trim()
            .toLowerCase()
            .regex(/^[a-z0-9]+$/, "Use lowercase letters and digits only"),
        kind: z.enum(["bills", "invoices"]),
        entityUuid: z.string().uuid(),
        counterpartyId: z.string().uuid().nullable().optional(),
    })
    .strict();

export const createWorkspaceEmailAliasSchema = z.union([
    createEntityCounterpartyWorkspaceEmailAliasSchema,
    createChosenWorkspaceEmailAliasSchema,
    createGeneratedWorkspaceEmailAliasSchema,
]);

export type CreateWorkspaceEmailAliasRequest = z.infer<
    typeof createWorkspaceEmailAliasSchema
>;

export const listWorkspaceEmailAliasesResponseSchema = z.object({
    emailAliases: z.array(workspaceEmailAliasSchema),
});

export type ListWorkspaceEmailAliasesResponse = z.infer<
    typeof listWorkspaceEmailAliasesResponseSchema
>;
